//(function () {
//	'use strict';

//    const module = angular.module('imApp');

//    module.component('pohTop', {
//        templateUrl: 'views/components/views/pohTop/pohTop.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'pohTopService', 'posComponentService', function ($stateParams, stateService, utilityService, pohTopService, posComponentService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let pohKeynoTop = $stateParams.poh_keyno_top;
            
//    		vm.model = {
//    			edit: {},
//    			selectListPoStatus: [],
//    			itemsListSubPos: []
//    		};

//            // #endregion VARIABLES & DEFINITIONS

//    		// #region LOAD PROCEDURE CALLS

//            async function loadEdit() {
//                vm.model.edit = (await pohTopService.getEdit({ poh_keyno_top: pohKeynoTop }))[0];
//            }

//            async function loadPoStatuses() {
//                vm.model.selectListPoStatus = await posComponentService.listPoStatuses({ add_all: '0' });
//            }
            
//            async function loadSubPos() {
//                if (utilityService.validateParmsValue(vm.model.edit.poh_keyno_top) !== true) return;

//                vm.model.itemsListSubPos = await pohTopService.listSubPos({ poh_keyno_top: vm.model.edit.poh_keyno_top });
//    		}

//            // #endregion LOAD PROCEDURE CALLS

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'selectreport':
//                        go({
//                            webpage_name: stateService.getCurrentName(),
//                            argtype: 'poh_keyno_top',
//                            argvalue: vm.model.edit.poh_keyno_top
//                        });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                await loadEdit();
//                loadPoStatuses();
//                loadSubPos();
//            }

//            // #endregion ON INIT FUNCTION

//    	}]
//    });
//})();
